module.exports = __webpack_public_path__ + "static/media/politicas.2860ee7a.pdf";